import { render, staticRenderFns } from "./ProjectsOverviewNew.vue?vue&type=template&id=15ca080f&"
import script from "./ProjectsOverviewNew.vue?vue&type=script&lang=js&"
export * from "./ProjectsOverviewNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports